export const configNewDevice = /* GraphQL */ `
  mutation configureDevice($deviceConfig: deviceConfigRequest!) {
    configureDevice(deviceConfig: $deviceConfig) {
      success
    }
  }
`;
export const configureNewDeviceMutatiom = /* GraphQL */ `
  mutation configureNewDevice($deviceConfigNew: deviceConfigNewRequest!) {
    configureNewDevice(deviceConfigNew: $deviceConfigNew) {
      success
    }
  }
`;

export const disconnectDeviceMutation = /* GraphQL */ `
  mutation disconnectDevice($device: disconnectRequest!) {
    disconnectDevice(device: $device) {
      success
    }
  }
`;
export const disconnectMultipleDeviceMutation = /* GraphQL */ `
  mutation disconnectMultipleDevice(
    $disconnectDevices: disconnectMultipleDeviceRequest!
  ) {
    disconnectMultipleDevice(disconnectDevices: $disconnectDevices) {
      success
    }
  }
`;
export const unlinkMultipleDeviceMutation = /* GraphQL */ `
  mutation unlinkMultipleDevice($unlinkDevices: unlinkMultipleDeviceRequest!) {
    unlinkMultipleDevice(unlinkDevices: $unlinkDevices) {
      success
    }
  }
`;

export const createNewTenantMutation = /* GraphQL */ `
  mutation createLocation($location: LocationRequest!) {
    createLocation(location: $location) {
      success
    }
  }
`;
export const updateLocationOrderMutation = /* GraphQL */ `
  mutation updateLocationOrder($locationOrder: LocationOrderRequest!) {
    updateLocationOrder(locationOrder: $locationOrder) {
      success
    }
  }
`;
export const updateUserTemperatureInfoMutation = /* GraphQL */ `
  mutation updateUserTemperatureInfo($temperatureData: UpdateUserTemperatureInfoRequest!) {
    updateUserTemperatureInfo(temperatureData: $temperatureData) {
      success
    }
  }
`;

export const changeRolePermissionMutation = /* GraphQL */ `
  mutation changeRolePermission($rolePermission: permissionRequest!) {
    changeRolePermission(rolePermission: $rolePermission) {
      success
    }
  }
`;

export const createTenantMutation = /* GraphQL */ `
  mutation createTenant($tenant: TenantRequest!) {
    createTenant(tenant: $tenant) {
      success
      message
    }
  }
`;

export const changeTenantStatusMutation = /* GraphQL */ `
  mutation changeTenantStatus($changeStatus: changeStatusRequest!) {
    changeTenantStatus(changeStatus: $changeStatus) {
      success
    }
  }
`;

export const deleteTenantMutation = /* GraphQL */ `
  mutation deleteTenant($deleteTenant: deleteTenantRequest!) {
    deleteTenant(deleteTenant: $deleteTenant) {
      success
    }
  }
`;

export const createNewTenantUserMutation = /* GraphQL */ `
  mutation createNewTenantUser($user: TenantUserRequest!) {
    createNewTenantUser(user: $user) {
      success
      message
    }
  }
`;

export const createNewCreateNewAdminMutation = /* GraphQL */ `
  mutation createNewAdmin($admin: AdminRequest!) {
    createNewAdmin(admin: $admin) {
      success
    }
  }
`;

export const deleteTenantUserMutation = /* GraphQL */ `
  mutation deleteTenantUser($userId: [String]!, $tenantId:String ) {
    deleteTenantUser(userId: $userId, tenantId:$tenantId) {
      success
    }
  }
`;

export const enableDisableUserMutation = /* GraphQL */ `
  mutation enableDisableUser($statusRequest: changeUserStatusRequest!) {
    enableDisableUser(statusRequest: $statusRequest) {
      success
    }
  }
`;

export const getUserDetailsMutation = /* GraphQL */ `
  mutation getUserDetails($userDetail: userDetailRequest!) {
    getUserDetails(userDetail: $userDetail) {
      tenantId
      name
      middle_name
      public_sso
      tenantCode
      isActive
      default_location
      default_type
      group
      created_at
      permission
      userFacility
      profile
      email_message
      message
      notification
      enable_mfa
      phone
      force_mfa
      dashboard_view
      tenant_info
      timezone
      last_login
      last_updated
      profile_updated
      temperature_unit
      querySubstanceHistory
      substanceHistory
      scheduleReportSubstanceHistory
      timeseriesSubstanceHistory
      location_info
      generateNotificationSubstanceHistory
    }
  }
`;

export const updateUserConfigMutation =/* GraphQL */ `mutation updateUserConfig($userConfig:userConfigRequest!) {
  updateUserConfig(userConfig: $userConfig) {
    success
    message
  }
}`;

export const addLocationWithCsvMutation = /* GraphQL */ `
  mutation addLocationWithCsv($csvData: csvListRequest!) {
    addLocationWithCsv(csvData: $csvData) {
      roomUploaded
      emptyRoom
      deviceUploaded
      deviceNotUploaded
    }
  }
`;

export const updateCalibrationMutation = /* GraphQL */ `
  mutation updateCalibration($calibration: calibrationRequest!) {
    updateCalibration(calibration: $calibration) {
      success
    }
  }
`;

export const setLocation = /* GraphQL {key: "5slrh587", type: "1", tenantId: "35cbaf3f-4fa4-4e2a-a36c-9cc02243b906"} */ `
mutation setDefaultLocation($defaultLocation: defaultLocationRequest!) {
  setDefaultLocation(defaultLocation: $defaultLocation) {
    success
  }
}
`;
export const createEventMap = /* GraphQL {florId:"f66sr0uq",image_data:'',image_map_data:'',wardId:''} */ `
mutation addEventMap($addEventMap: addEventMapRequest!) {
  addEventMap(addEventMap: $addEventMap) {
    success
  }
}
`;
export const updateEventMap = /* GraphQL {florId:"f66sr0uq",image_data:'',image_map_data:'',wardId:''} */ `
mutation editEventMap($editEventMap: editEventMapRequest!) {
  editEventMap(editEventMap: $editEventMap) {
    success
  }
}
`;
export const deleteEventMap = `
mutation deleteEventMap($deleteEventMap: deleteEventMapRequest!) {
  deleteEventMap(deleteEventMap: $deleteEventMap) {    
    success
  }
}
`;
export const deleteLocationsMutation = /* GraphQL */ `
  mutation deleteLocations($deleteLocation: deleteLocationRequest!) {
    deleteLocations(deleteLocation: $deleteLocation) {
      success
    }
  }
`;

export const recoverLocationsMutation = /* GraphQL */ `
  mutation recoverLocation($recoverLocation: deleteLocationRequest!) {
    recoverLocation(recoverLocation: $recoverLocation) {
      success
    }
  }
`;

export const linkDevices = /* GraphQL */ `
  mutation devicesImport($devicesImport: devicesImportRequest!) {
    devicesImport(devicesImport: $devicesImport) {
      success
    }
  }
`;
export const linkMultiDevices = /* GraphQL */ `
  mutation linkDevices($linkDevices: linkDevicesRequest!) {
    linkDevices(linkDevices: $linkDevices) {
      success
    }
  }
`;

export const updateCalibrationNewMutation = /* GraphQL */ `
  mutation saveUpdateCalibration($newCalibration: calibrationNewRequest!) {
    saveUpdateCalibration(newCalibration: $newCalibration) {
      success
      message
    }
  }
`;

export const addLogsAws = /* GraphQL */ `
  mutation addLogs($addLogs: addlogsRequest!) {
    addLogs(addLogs: $addLogs) {
      success
    }
  }
`;

export const recoverTenantMutation = /* GraphQL */ `
  mutation recoverTenant($recoverId: deleteTenantRequest!) {
    recoverTenant(recoverId: $recoverId) {
      success
    }
  }
`;

export const recoverTenantUserMutation = /* GraphQL */ `
  mutation recoverTenantUser($userId: [String]!,$tenantId:String) {
    recoverTenantUser(userId: $userId, tenantId: $tenantId) {
      success
    }
  }
`;
export const resetUserPasswordMutation = /* GraphQL */ `
  mutation changeTenantPasswordAdmin($adminChangePassword: adminChangePasswordRequest!) {
    changeTenantPasswordAdmin(adminChangePassword: $adminChangePassword) {
      success
      message
    }
  }
`;

export const udpateRoleMutation = /* GraphQL */ `
  mutation updateRole($roleUpdate: updateRoleRequest!) {
    updateRole(roleUpdate: $roleUpdate) {
      success
    }
  }
`;

export const deleteRoleMutation = /* GraphQL */ `
  mutation deleteRole($roleDelete: deleteRoleRequest!) {
    deleteRole(roleDelete: $roleDelete) {
      success
    }
  }
`;

export const addNewRoleMutation = /* GraphQL */ `
  mutation addNewRole($role: addNewRoleRequest!) {
    addNewRole(role: $role) {
      success
    }
  }
`;

export const recoverRoleMutation = /* GraphQL */ `
  mutation recoverRole($roleRecover: deleteRoleRequest!) {
    recoverRole(roleRecover: $roleRecover) {
      success
    }
  }
`;

export const resetPasswordMutation = /* GraphQL */ `
  mutation resetUserPassword($reset: resetPasswordRequest!) {
    resetUserPassword(reset: $reset) {
      success
    }
  }
`;

export const getUserDataMutation = /* GraphQL */ `
  mutation getUserData($accessToken: getUserDataRequest!) {
    getUserData(accessToken: $accessToken) {
      success
    }
  }
`;

export const addGrafanaMutation = /* GraphQL */ `
  mutation addGrafana($addGrafana: addGrafanaRequest!) {
    addGrafana(addGrafana: $addGrafana) {
      success
    }
  }
`;

export const updateGrafanaMutation = /* GraphQL */ `
  mutation updateGrafana($updateGrafana: updateGrafanaRequest!) {
    updateGrafana(updateGrafana: $updateGrafana) {
      success
    }
  }
`;
export const createNewCategory = /* GraphQL {category:"Gas"} */ `
mutation addCategory($addCategory: addCategoryRequest!) {
  addCategory(addCategory: $addCategory) {
    success
  }
}
`;
export const createNewMasterCategory = /* GraphQL {category:"Gas"} */ `
mutation addCategoryMaster($addCategoryMaster: addCategoryMasterRequest!) {
  addCategoryMaster(addCategoryMaster: $addCategoryMaster) {
    success
  }
}
`;

export const createNewUserGrafanaDashboard = /* GraphQL */ `
mutation addOrUpdateUserGrafanaDashboard($addOrUpdateUserGrafanaDashboard: addOrUpdateUserGrafanaDashboardRequest!) {
  addOrUpdateUserGrafanaDashboard(addOrUpdateUserGrafanaDashboard: $addOrUpdateUserGrafanaDashboard) {
    message
    success
  }
}
`;

export const renameUserGrafanaDashboard = /* GraphQL */ `
mutation renameUserGrafanaDashboard($renameUserGrafanaDashboard: renameUserGrafanaDashboardRequest!) {
  renameUserGrafanaDashboard(renameUserGrafanaDashboard: $renameUserGrafanaDashboard) {
    message
    success
  }
}
`;

export const deleteUserGrafanaDashboard = /* GraphQL */ `
mutation deleteUserGrafanaDashboard($deleteUserGrafanaDashboard: deleteUserGrafanaDashboardRequest!) {
  deleteUserGrafanaDashboard(deleteUserGrafanaDashboard: $deleteUserGrafanaDashboard) {
    message
    success
  }
}
`;

export const createNewSubstance = /* GraphQL {category:"Gas"} */ `
mutation addSubstance($addSubstance: addSubstanceRequest!) {
  addSubstance(addSubstance: $addSubstance) {
    success
  }
}
`;

export const changeCategorySubstance = /* GraphQL {category:"Gas"} */ `
mutation changeCategorySubstance($changeCategorySubstance: changeCategorySubstanceRequest!) {
  changeCategorySubstance(changeCategorySubstance: $changeCategorySubstance) {
    success
  }
}
`;

export const configDeviceNew = /* GraphQL ON 16 Jun 2023 */ `
  mutation configDeviceNew($configDevices: configDevicesRequest!) {
    configDeviceNew(configDevices: $configDevices) {
      success
    }
  }
`;

export const uploadEventMapImg = `
mutation uploadImage($uploadImage: imageUploadRequest!) {
  uploadImage(uploadImage: $uploadImage) {    
    success
    imageUrl
  }
}
`;

export const deleteImg = `
mutation deleteimage($deleteimage: deleteImageRequest!) {
  deleteimage(deleteimage: $deleteimage) {
    imageUrl
    success
  }
}
`;

export const addSubstanceConfig = /* GraphQL */ `
  mutation addSubstanceConfiguration($addSubstanceConfiguration: addSubstanceConfigurationRequest!) {
    addSubstanceConfiguration(addSubstanceConfiguration: $addSubstanceConfiguration) {
      success
    }
  }
`;

export const addNewSubstanceConfig = /* GraphQL */ `
  mutation addNewSubstanceConfiguration($addNewSubstanceConfiguration: substanceConfig!) {
    addNewSubstanceConfiguration(addNewSubstanceConfiguration: $addNewSubstanceConfiguration) {
      success
      message
    }
  }
`;

export const updateSubstanceConfig = /* GraphQL */ `
  mutation updateSubstanceConfiguration($updateSubstanceConfiguration: updateSubstanceConfigurationRequest!) {
    updateSubstanceConfiguration(updateSubstanceConfiguration: $updateSubstanceConfiguration) {
      success
    }
  }
`;
export const deleteSubstanceConfig = /* GraphQL */ `
  mutation deleteSubstanceConfiguration($deleteSubstanceConfiguration: deleteSubstanceConfigurationRequest!) {
    deleteSubstanceConfiguration(deleteSubstanceConfiguration: $deleteSubstanceConfiguration) {
      success
    }
  }
`;
export const setDefaultOrder = /* GraphQL */ `
  mutation setDefaultOrderAllTiles($tenantCode: String!) {
    setDefaultOrderAllTiles(tenantCode: $tenantCode) {
      success
      message
    }
  }
`;
export const enableMFAMutation = /* GraphQL */ `
  mutation userEnableMFA($userEnableMFA: mfaEnableRequest!) {
    userEnableMFA(userEnableMFA: $userEnableMFA) {
      success
      message
    }
  }
`;
export const updateUserProfileMutation =/* GraphQL */
  `mutation updateUserProfile($userProfile:updateProfileRequest!) {
  updateUserProfile(userProfile: $userProfile) {
    success
    message
  }
}`;
export const sendOTPCodeMutation =/* GraphQL */
  `mutation sendOTPCode($sendCode:sendCodeRequest!) {
  sendOTPCode(sendCode: $sendCode) {
    success
    message
  }
}`;

export const verifyOTPCodeMutation =/* GraphQL */
  `mutation verifyOTPCode($verifyOtp:verifyOTPCodeRequest!) {
  verifyOTPCode(verifyOtp: $verifyOtp) {
    success
    message
  }
}`;

export const addThresholdNotificationMutation =/*GraphQL*/ `mutation addThresholdNotification($threshold:thresholdNotificationRequest!) {
  addThresholdNotification(threshold:$threshold) {
    message
    success
  }
}`;

export const addThresholdNotificationChanelMutation =/*GraphQL*/
  `mutation addThresholdNotificationChanel($channel:thresholdNotificationChannelRequest!) {
  addThresholdNotificationChanel(channel: $channel) {
    message
    success
  }
}`;

export const updateThresholdMutation =/*GraphQL*/
  `mutation updateThreshold($params:ThresholdUpdateRequest!) {
  updateThreshold(params: $params) {
    message
  }
}`;

export const restoreThresholdDefaultMutation =/*GraphQL*/
  `mutation restoreDefaultThreshold($params:ThresholdRequest!){
  restoreDefaultThreshold(params: $params) {
    message
  }
}`;

export const updateNotificationStatusMutation =/*GraphQL*/
  `mutation updateUserNotificationsIsRead($update:updateUserNotificationsIsReadRequest!) {
  updateUserNotificationsIsRead(update: $update) {
    message
    success
  }
}`;

export const updateAllNotificationStatusMutation =/*GraphQL*/
  `mutation updateReadMarkAll($userName:String! $isStatus: Boolean) {
  updateReadMarkAll(userName: $userName isStatus: $isStatus) {
    message
    success
  }
}`;


export const addInternalIdsMutation =/*GraphQL*/
  `mutation createInternalDeviceIds($internalIds:createInternalIdsRequest!) {
  createInternalDeviceIds(internalIds: $internalIds) {
    message
    success
  }
}`
export const internalIdLinkMutation =/*GraphQL*/
  `mutation internalDeviceIdLinkWithTenant($internallink:internalLinkWithTenantRequest!) {
  internalDeviceIdLinkWithTenant(internallink: $internallink) {
    message
    success
  }
}`;
export const internalIdUnlinkMutation =/*GraphQL*/
  `mutation internalDeviceIdUnLinkWithTenant($internalunlink:internalUnLinkWithTenantRequest!) {
  internalDeviceIdUnLinkWithTenant(internalunlink: $internalunlink) {
    message
    success
  }
}`;

export const getSubstanceHistoryMutation =/*GraphQL*/
  `mutation getSubstanceNotificationHistory($substance:[String] $locationIds:[String] $pageNo:String) {
  getSubstanceNotificationHistory(substance: $substance locationIds: $locationIds pageNo: $pageNo) {
    data {      
      totalPage
      pageNo
      items {
        entryTime
        device
        index
        pk
        sen_id
        ua
        value
        device_loc
      }
      name
    }
  }
}`;

export const DeviceIdLinkWithInternalIdMutation =/*GraphQL*/
  `mutation deviceLinkWithInternalId($deviceinternalidlink:deviceInternalIdLinkRequest!) {
  deviceLinkWithInternalId(deviceinternalidlink: $deviceinternalidlink) {
    message
    success
  }
}`
export const sendContactSupportMutation = /* GraphQL */ `
  mutation contactSupportEmail($contactSupport: contactSupportRequest!) {
    contactSupportEmail(contactSupport: $contactSupport) {
      success
      message
    }
  }
`;
export const getLatestSubstanceDataMutation =/*GraphQL*/
  `mutation getLatestSubstanceData($devices:[String]) {
  getLatestSubstanceData(devices: $devices)
  {                
    index
    substance
    device    
  }
}`;

export const createEmailTemplateMutation = /* GraphQL */ `
  mutation createEmailTemplate($createEmailTemplate: createEmailTemplateRequest!) {
    createEmailTemplate(createEmailTemplate: $createEmailTemplate) {
      success
      message
    }
  }
`;
export const deleteEmailTemplateMutation = /* GraphQL */ `
  mutation deleteEmailTemplate($deleteEmailTemplate: deleteEmailTemplateRequest!) {
    deleteEmailTemplate(deleteEmailTemplate: $deleteEmailTemplate) {
      success
      message
    }
  }
`;
export const sendEmailUserMutation = /* GraphQL */ `
  mutation sendSESEmail($sendEmail: sendEmailRequest!) {
    sendSESEmail(sendEmail: $sendEmail) {
      success
      message
    }
  }
`;
export const deleteSendEmailMutation = /* GraphQL */ `
  mutation deleteSendEmail($deleteEmail: deleteEmailRequest!) {
    deleteSendEmail(deleteEmail: $deleteEmail) {
      success
      message
    }
  }
`;
export const updateUserDefaultViewMutation = /* GraphQL */ `
  mutation updateUserDashboardDefault($dashboard_view: String, $username: String) {
    updateUserDashboardDefault(dashboard_view: $dashboard_view, username: $username) {
      message
      success
    }
  }
`;
export const updateTenantInfoMutation = /* GraphQL */ `
  mutation updateDefaultTenant($tenant_info: String, $username: String) {
    updateDefaultTenant(tenant_info: $tenant_info, username: $username) {
      message
      success
    }
  }
`;
export const createThirdPartyDeviceProviderMutation = /* GraphQL */ `
  mutation createThirdPartyDeviceProvider($provider: thirdPartyDeviceProviderRequest!) {
    createThirdPartyDeviceProvider(provider: $provider) {
      message
      success
    }
  }
`;

export const deleteThirdPartyDeviceProviderMutation = /* GraphQL */ `
  mutation deleteIntegrationDevice($deleteIntegrationDevice: deleteThirdPartyDeviceProviderRequest!) {
    deleteIntegrationDevice(deleteIntegrationDevice: $deleteIntegrationDevice) {
      message
      success
    }
  }
`;
export const removeRoomFromUnitMutation = /* GraphQL */ `
  mutation removeRoomFromUnit($removeRoomFromUnit: removeRoomFromUnitRequest!) {
    removeRoomFromUnit(removeRoomFromUnit: $removeRoomFromUnit) {
      success
    }
  }
`;
export const addDeviceHistoryMutation = /* GraphQL */ `
  mutation createdeviceHistory($createdevicehistory: deviceHistoryRequest!) {
    createdeviceHistory(createdevicehistory: $createdevicehistory) {
      success
    }
  }
`;

//Saving User selected Facility user wise
export const updateDefaultLocationMutation = /* GraphQL */ `
  mutation updateDefaultLocation($updateDefaultLocation: updateDefaultLocationRequest!) {
    updateDefaultLocation(updateDefaultLocation: $updateDefaultLocation) {
      success
    }
  }
`;
// sendTemporaryPassword whenever expire temporary password
export const sendTemporaryPasswordMutation = /* GraphQL */ `
  mutation sendTemporaryPassword($username:String!) {
    sendTemporaryPassword(username: $username) {
      success
      message
    }
  }
`;
export const verifyUserForSingleSignInMutation = /* GraphQL */ `
  mutation verifyUserForSingleSignIn($userData:UserDataRequest!) {
    verifyUserForSingleSignIn(userData: $userData) {
      success
      message
    }
  }
`;
export const addDeviceVersionMutation = /* GraphQL */ `
  mutation createDeviceVersion($deviceVersion:DeviceVersionRequest!) {
    createDeviceVersion(deviceVersion: $deviceVersion) {
      success
      message
    }
  }
`;
export const linkVersionToDeviceMutation = /* GraphQL */ `
  mutation linkVersionToDevice($linkVersion:LinkVersionToDeviceRequest!) {
    linkVersionToDevice(linkVersion: $linkVersion) {
      success
      message
    }
  }
`;
export const storeFacility3DSpaceIdMutation = /* GraphQL */`
  mutation storeFacility3DSpaceIdM($storeSpaceId:StoreSpaceIdRequest){
    storeFacility3DSpaceIdM(storeSpaceId:$storeSpaceId){
      success
      message
    }
  }
`
export const store3DFacilityDeviceLocationMutation =/* GraphQL */`
  mutation store3DFacilityDeviceLocations($storeDeviceLocation:Store3DFacilityDeviceLocType){
    store3DFacilityDeviceLocations(storeDeviceLocation:$storeDeviceLocation){
      success
      message
    }
  }
`
export const addUpdateCustomNotificationRulesMutation =/* GraphQL */`
  mutation addUpdateCustomNotificationRules($notificationrules:notificationRulesRequest){
    addUpdateCustomNotificationRules(notificationrules:$notificationrules){
      success
      message
    }
  }`

export const saveUpdateDashboardWidgets = /* GraphQL */`
mutation saveUpdateDashboardWidgets($saveRequestDashboardWidgets:dashboardWidgetsRequest!){
  saveUpdateDashboardWidgets(saveRequestDashboardWidgets:$saveRequestDashboardWidgets){
    success
    message
  }
}`

export const downLoadDeviceRawDataMutation = /* GraphQL */ `
  mutation downloadDeviceRawData($downloadRawData:downloadRawDataRequest!) {
    downloadDeviceRawData(downloadRawData: $downloadRawData) {
      success
      csvUrl
    }
  }
`;
export const storeRecentSubstanceHistoryMutation = /* GraphQL */ `
  mutation storeRecentSubstanceHistory($recentSubstanceHistoryRequest:recentSubstanceHistoryRequest) {
    storeRecentSubstanceHistory(recentSubstanceHistoryRequest:$recentSubstanceHistoryRequest) {
      message
      success
    }
  }
`;
export const storeUserLocationDetailsMutation = /* GraphQL */ `
  mutation storeUserLocationDetails($storeUserLocationDetailRequest:storeUserLocationDetailRequest) {
    storeUserLocationDetails(storeUserLocationDetailRequest:$storeUserLocationDetailRequest) {
      message
      success
    }
  }
`;

export const addThirdPartyDevicesMutation = /* GraphQL */ `
  mutation addThirdPartyDevices($devices: addThirdPartyDeviceRequest!) {
    addThirdPartyDevices(devices: $devices) {
      message
      success
    }
  }
`;

export const AddThirdPartyDeviceConfigurationMutation = /* GraphQL */ `
  mutation AddThirdPartyDeviceConfiguration($thirdPartyDevicesConfiguration: thirdPartyDevicesConfigurationRequest!) {
    AddThirdPartyDeviceConfiguration(thirdPartyDevicesConfiguration: $thirdPartyDevicesConfiguration) {
      message
      success
    }
  }
`;

export const DeleteDeviceConfigurationMutation = /* GraphQL */ `
  mutation deleteDeviceConfiguration($deleteDeviceConfiguration: deleteThirdPartyDeviceConfigurationRequest!) {
    deleteDeviceConfiguration(deleteDeviceConfiguration: $deleteDeviceConfiguration) {
      message
      success
    }
  }
`;

export const AddProviderMutation = /* GraphQL */ `
  mutation addProvider($addProvider: addProviderRequest!) {
    addProvider(addProvider: $addProvider) {
      message
      success
    }
  }
`;



